import React from 'react';
import { Button } from 'primereact/button';
import { bdi_label, bdi_icon, bdi_iconposition, bdi_classe, bdi_subclasse, bdi_alinhamento_lateral, bdi_alinhamento_vertical } from './AtributosBDI';

const ButtonBDI = props => {
    return React.createElement(Button, {
        label: props.label,
        icon: props.icon,
        iconPos: props.iconPos,
        className: props.className,
        onClick: props.funcao,
        disabled: props.disabled
    });
};

ButtonBDI.bdi_label = bdi_label;
ButtonBDI.bdi_icon = bdi_icon;
ButtonBDI.bdi_iconposition = bdi_iconposition;
ButtonBDI.bdi_classe = bdi_classe;
ButtonBDI.bdi_subclasse = bdi_subclasse;
ButtonBDI.bdi_alinhamento_lateral = bdi_alinhamento_lateral;
ButtonBDI.bdi_alinhamento_vertical = bdi_alinhamento_vertical;

export default ButtonBDI;